export default "__VITE_ASSET__DMvn0czj__"